import { ADD_PRODUCT_TO_CART, UPDATE_PRODUCT_CART } from '~/store/actions/CartProductAction/type';

const initState = {
    cartProductInfo: JSON.parse(localStorage.getItem('cartProduct')) || [],
};

const CartProductReducer = (state = initState, action) => {
    switch (action.type) {
        case ADD_PRODUCT_TO_CART: {
            let newState = { ...state };
            const newItem = { ...action.payload };
            let index = -1;
            let checkIdSharer = false;
            newItem.key = newItem.id + newItem.sharer_id;
            if (newItem?.sharer_id) {
                for (let i = 0; i < newState.cartProductInfo?.length; i++) {
                    if (
                        newState.cartProductInfo[i].id === newItem.id &&
                        newState.cartProductInfo[i].sharer_id === newItem.sharer_id
                    ) {
                        index = i;
                    }
                }
                if (index === -1) {
                    for (let i = 0; i < newState.cartProductInfo?.length; i++) {
                        if (newState.cartProductInfo[i].id === newItem.id && newState.cartProductInfo[i].sharer_id) {
                            index = i;
                            checkIdSharer = true;
                        }
                    }
                }
            } else {
                for (let i = 0; i < newState.cartProductInfo?.length; i++) {
                    if (newState.cartProductInfo[i].id === newItem.id && !newState.cartProductInfo[i].sharer_id) {
                        index = i;
                    }
                }
            }

            for (let i = 0; i < newState.cartProductInfo?.length; i++) {
                if (newState.cartProductInfo[i].id === newItem.id) {
                    newState.cartProductInfo[i].thumbnail = newItem.thumbnail;
                    newState.cartProductInfo[i].title = newItem.title;
                    newState.cartProductInfo[i].price = newItem.price;
                    if (newState.cartProductInfo[i].sharer_id) {
                        newState.cartProductInfo[i].sale_price = (newItem.price * 5) / 100;
                    } else {
                        newState.cartProductInfo[i].sale_price = 0;
                    }
                    newState.cartProductInfo[i].deducted_price =
                        newState.cartProductInfo[i].price - newState.cartProductInfo[i].sale_price;

                    newState.cartProductInfo[i].total_price =
                        newState.cartProductInfo[i].amount * newState.cartProductInfo[i].deducted_price;
                }
            }

            if (index >= 0) {
                // San pham da co trong gio hang
                if (checkIdSharer) {
                    newState.cartProductInfo[index] = newItem;
                    newState.cartProductInfo[index].deducted_price =
                        newState.cartProductInfo[index].price - newState.cartProductInfo[index].sale_price;
                    newState.cartProductInfo[index].total_price =
                        newState.cartProductInfo[index].amount * newState.cartProductInfo[index].deducted_price;
                } else {
                    const amount = newState.cartProductInfo[index].amount;
                    newState.cartProductInfo[index] = newItem;
                    newState.cartProductInfo[index].amount = amount + newItem.amount;
                    newState.cartProductInfo[index].deducted_price =
                        newState.cartProductInfo[index].price - newState.cartProductInfo[index].sale_price;
                    newState.cartProductInfo[index].total_price =
                        newState.cartProductInfo[index].amount * newState.cartProductInfo[index].deducted_price;
                }
            } else {
                // San pham chua co trong gio hang
                newState.cartProductInfo.unshift(newItem);
            }

            localStorage.setItem('cartProduct', JSON.stringify(newState.cartProductInfo));
            return newState;
        }

        case UPDATE_PRODUCT_CART: {
            let newState = { ...state };
            const newCart = action.payload;
            newState.cartProductInfo = newCart;

            localStorage.setItem('cartProduct', JSON.stringify(newState.cartProductInfo));
            return newState;
        }

        default:
            return state;
    }
};

export default CartProductReducer;
